export default ($http) => ({

  getDashboardFavorites (query) {
    return $http.get('dashboard-favorites', { query })
  },

  deleteFromDashboardFavorites (id) {
    return $http.delete(`dashboard-favorites/${id}`)
  },

  deleteFromDashboardFavoritesMultiple (ids) {
    return $http.delete('dashboard-favorites-bulk', { body: { ids } })
  },

  getSharedFavoritesDetails (id) {
    return $http.get(`dashboard-favorites/${id}`)
  },

  addFavoritesToMy (id) {
    return $http.post(`dashboard-favorites-add-to-my/${id}`)
  }
})
